module.exports = __webpack_public_path__ + "img/category-coats.ce1e41e3.jpg";